import { gql } from "@apollo/client";
export default gql`
  mutation UpdateSMSCLink($input: UpdateSMSCLinkInput!) {
    updateSMSCLink(input: $input)
  }
`;
